<template lang="pug">
    v-card
        //loading-dialog(:loading="loadingData")
        //crud-data-table.px-5.mt-5(
            v-if="!loadingData"
            :service="serviceTable" 
            :headers="headerTable" 
            :deleteButton="()=>{true}" 
            noAutoWidth 
            @show="submitShow($event)" 
            noSearchBox
            :filters="[]"
            noActions
            )
        model-data-table(
            loading-text="Cargando notas de crédito..."
            no-data-text="Sin notas de crédito."
            no-search
            no-remove
            @detail="submitShow"
            ref="table"
            v-bind="tableProps"
            )
            template( slot='actions' slot-scope='props' )
                v-btn( icon @click='onPrint(props)' )
                    v-icon picture_as_pdf
        nc-detail-dialog(
          :creditNoteId="creditNoteId"
          :creditNoteModel="CreditNoteMdl"
          read-only
          ref='creditNoteDialog'
        )
        //- detail-dialog(ref="invoiceReceivableDialog" :invoiceId="invoiceId" readOnly)
</template>

<script>
//-
import { ModelDataTable } from '@/components/reusable_components/next'
import SlCreditNote from '@/models/Sale/SlSaleCreditNote'
import TableHeaders from './headers/creditNote.js'
import DetailCreditNoteDialog from '@/components/reusable_components/DocumentDetail/creditNote/CreditNoteDetail'
import CreditNoteModel from '@/models/Sale/SlSaleCreditNote'
// import DetailDialog from '@/components/dialogs/InvoiceDetailDialog'
//-
export default {
    name: 'customer-historic-invoice',
    props: {},
    data: function() {
        return {
            headerTable: TableHeaders,
            customerId: null,
            creditNoteId:null,
            CreditNoteMdl: CreditNoteModel,
        }
    },
    computed: {
        tableProps() {
            return {
                service: SlCreditNote,
                paramFilter: {
                    sl_customer_id: this.customerId,
                },
                headers: this.headerTable,
                filters: [
                    {
                        name: 'number',
                        type: 'text-field',
                        props: {
                            label: 'Folio',
                        },
                        flex: {
                            sm6: true,
                            lg5: true,
                        },
                    },
                ],
            }
        },
    },
    methods: {
        /**
         */
        setCustomerId() {
            
            this.customerId = this.$route.params.id
        },
        /**
         *
         */
        submitShow(event) {
            this.creditNoteId = event.item.id
            this.$refs.creditNoteDialog.open = true
        },
        
        /**
         * 
         */
        onPrint(event) {
            event.item.toPdf()
        },
    },
    watch: {},
    components: {
        'model-data-table': ModelDataTable,
        'nc-detail-dialog' :DetailCreditNoteDialog,
        //'detail-dialog': DetailDialog,
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setCustomerId()
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
